import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { EmployeePayload } from '@/modules/user/user.types';

const useEmployeeDataQuery = (employeeId?: string) => {
  const path = API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(employeeId || '');
  const { data, isSuccess, isError } = useQuery([path], () => api.get<EmployeePayload>(path), {
    enabled: !!employeeId,
  });
  const clearedRawData = useMemo(() => {
    const currentData = data?.data;
    delete currentData?.ssn;
    delete currentData?.partner_employee_id;
    delete currentData?.employer_employee_id;
    return currentData;
  }, [data?.data]);
  return {
    isError,
    isSuccess,
    rawData: clearedRawData,
  };
};
export default useEmployeeDataQuery;
